<template>
  <b-row>
    <b-col cols="12">
      <hr class="mt-1 mb-2">
      <span class="h6">{{$t("views.agreements.form.customFields")}}: </span>
    </b-col>
    <b-col cols="12">
      <b-row v-for="(field, fieldIndex) in data.agreementCustomFields" :key="'customField_'+fieldIndex">
        <div class="text-center d-md-inline-block align-self-center ml-3">
          <button
            type="button"
            class="btn btn-link fa fa-trash fa-lg"
            @click="removeCustomField(fieldIndex)"
            v-b-tooltip :title="$t('buttons.delete')">
          </button>
        </div>
        <b-col md="3">
          <b-form-group>
            <label :for="'fieldSelect_'+fieldIndex"></label>
            <model-select
              :id="'fieldSelect_'+fieldIndex"
              v-model="field.customField"
              @input="$forceUpdate()"
              :options="customFieldOptions">
            </model-select>
          </b-form-group>
        </b-col>
        <b-col md="8">
          <custom-field
            :custom-field-id="field.customField"
            :field-index="fieldIndex"
            :custom-field-initial-value="isUpdate ? field.value : null"
            @input="field.value = $event"
          ></custom-field>
        </b-col>
      </b-row>
      <button
        type="button"
        class="btn btn-primary"
        @click="addCustomField()"
      >
        {{ $t('buttons.addCustomField') }}
      </button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import CustomField from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/customField/CustomField'
import remove from '@/utils/remove'

export default {
  name: 'AgreementCustomFields',

  props: ['data', 'violations', 'isInvalid'],

  components: {
    ModelSelect,
    CustomField
  },

  data () {
    return {
      TYPE_INPUT: 1,
      TYPE_LABEL: 2,
      TYPE_DATE: 3,
      TYPE_SELECT: 4
    }
  },

  created () {
    if (this.isUpdate) {
      this.processInitialData()
    }
    this.fetchCustomFields()
  },

  computed: {
    isUpdate () {
      return this.$route.name === 'EXABAgreementsUpdate'
    },
    ...mapGetters({
      customFields: 'customfields/list/items'
    }),
    customFieldOptions () {
      return this.customFields.map(entry => {
        return {
          text: entry.label,
          value: entry['@id']
        }
      })
    }
  },

  methods: {
    processInitialData () {
      this.data.agreementCustomFields = this.data.agreementCustomFields.map(field => {
        return {
          '@id': field['@id'],
          customField: field.customField instanceof Object ? field.customField['@id'] : field.customField,
          value: field.value
        }
      })
    },

    addCustomField () {
      this.data.agreementCustomFields.push({
        agreement: this.isUpdate ? this.data['@id'] : null,
        customField: '',
        value: ''
      })
      this.$forceUpdate()
    },

    removeCustomField (fieldIndex) {
      let currentField = this.data.agreementCustomFields[fieldIndex]
      if (currentField['@id']) {
        remove(currentField['@id'], () => {
          this.data.agreementCustomFields.splice(fieldIndex, 1)
          this.$forceUpdate()
        })
      } else {
        this.data.agreementCustomFields.splice(fieldIndex, 1)
        this.$forceUpdate()
      }
    },

    ...mapActions({
      fetchCustomFields: 'customfields/list/getItems'
    })
  }
}
</script>

<style scoped>

</style>
